module.exports = __webpack_public_path__ + "media/images/icons/real_world-13444a5bac0e2a7423d073d261f93f88.svg";